const Storage = {
  PREFIX: 'sim',
  ACCESS_TOKEN: 'access-token',
  REFRESH_TOKEN: 'refresh-token',
  COLLAPSED: 'collapsed',
  MENU_OPEN_KEYS: 'menu-open-keys',
  USER_INFO: "user-info",
  API_PLAYGROUND_SIDEBAR_WIDTH: "api-playground-sidebar-width",
  API_PLAYGROUND_PANEL_HEIGHT: "api-playground-panel-height",
  API_PLAYGROUND_TABS: "api-playground-tabs",
  API_PLAYGROUND_ACTIVE_TAB: "api-playground-active-tab",
  API_PLAYGROUND_EXPANDED_KEYS: "api-playground-expanded-keys",
  API_PLAYGROUND_SIDEBAR_TAB: "api-playground-sidebar-tab",
  API_PLAYGROUND_SELECTED_PROJECT: "api-playground-selected-project",
  API_PLAYGROUND_SELECTED_KEY: "api-playground-selected-key",
  API_PLAYGROUND_HIDDEN_PROJECTS: "api-playground-hidden-projects"
};

export default Storage;
